// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_header__A7NEZ {
  width: 100%;
  position: relative;
  z-index: 3;
  min-height: var(--header-height);
}
.header_header__wp__HfD7X {
  transition: var(--transition);
  transition-property: box-shadow;
}
@media (min-width: 1200px) {
  .header_header__wp__HfD7X {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    background-color: #fff;
  }
}
.header_header__inner__eBlOw {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (min-width: 1200px) {
  .header_header__inner__eBlOw {
    flex-direction: row-reverse;
    max-width: var(--container);
    min-height: var(--header-height);
    padding: 8px var(--grid-spacing);
    margin: 0 auto;
  }
}
.header_header__links__JaL2y {
  display: flex;
  align-items: center;
}
.header_header__logo__8KhJ7 a {
  max-height: 48px;
  display: block;
}
@media (min-width: 1200px) {
  .header_header__logo__8KhJ7 a {
    height: auto;
  }
}
.header_header__logo__8KhJ7 img {
  width: auto;
  max-height: 48px;
  max-width: 100px;
}
@media (min-width: 640px) {
  .header_header__logo__8KhJ7 img {
    max-height: 40px;
    max-width: 150px;
  }
}
@media (min-width: 1200px) {
  .header_header__logo__8KhJ7 img {
    max-height: 40px;
  }
}
.header_header__logo__container__Xgayt {
  display: block;
}
.header_header__logo__container__Xgayt svg, .header_header__logo__container__Xgayt img {
  width: auto;
  max-height: 48px;
  max-width: 100px;
}
@media (min-width: 640px) {
  .header_header__logo__container__Xgayt svg, .header_header__logo__container__Xgayt img {
    max-height: 40px;
    max-width: 150px;
  }
}
@media (min-width: 1200px) {
  .header_header__logo__container__Xgayt svg, .header_header__logo__container__Xgayt img {
    max-height: 40px;
  }
}
.header_header__auth__cKTpv {
  display: flex;
  align-items: center;
}
.header_header__avatar__ONRMI {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #FFF;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.16);
  background: #EEE;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}
@media (min-width: 640px) {
  .header_header__avatar__ONRMI {
    width: 64px;
    height: 64px;
  }
}
@media (min-width: 1200px) {
  .header_header__avatar__ONRMI {
    width: 30px;
    height: 30px;
  }
}
.header_header__avatar__ONRMI svg {
  position: relative;
  z-index: 1;
}
@media (min-width: 640px) {
  .header_header__avatar__ONRMI svg {
    width: 30px;
    height: 30px;
  }
}
@media (min-width: 1200px) {
  .header_header__avatar__ONRMI svg {
    width: auto;
    height: auto;
  }
}
.header_header__avatar__ONRMI img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #fff;
}
.header_header__name__ttvD2 {
  font-weight: 600;
  color: #000;
  margin-left: 8px;
  font-size: 16px;
  line-height: 100%;
}
@media (min-width: 640px) {
  .header_header__name__ttvD2 {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .header_header__name__ttvD2 {
    font-size: var(--fz-md);
  }
}
.header_header--is-mob-hidden__Hvq6Y {
  display: none;
}
@media (min-width: 1200px) {
  .header_header--is-mob-hidden__Hvq6Y {
    display: block;
  }
}
.header_header--is-scrolled__FLcuh .header_header__wp__HfD7X {
  box-shadow: none;
}
@media (min-width: 1200px) {
  .header_header--is-scrolled__FLcuh .header_header__wp__HfD7X {
    box-shadow: 0 2px 8px rgba(152, 168, 188, 0.2);
  }
}
.header_header__A7NEZ .header_header__not-logined__EVLlc .header_header__inner__eBlOw {
  flex-direction: row-reverse;
  margin-bottom: 24px;
}
@media (min-width: 1200px) {
  .header_header__A7NEZ .header_header__not-logined__EVLlc .header_header__inner__eBlOw {
    margin-bottom: 0;
  }
}
.header_header__A7NEZ .header_header__not-logined__EVLlc .header_header__inner__eBlOw .header_mob__login-btn__MO7AY {
  font-size: 12px;
  padding: 12px 24px;
  background: #EEEEEE;
  font-weight: 600;
  border-radius: 12px;
}
.header_header__A7NEZ .header_fio-container__lCwJh {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 16px;
}

.header_lang__HTYK9 {
  display: none;
}
@media (min-width: 1200px) {
  .header_lang__HTYK9 {
    display: block;
    margin-right: 16px;
  }
}
.header_lang__HTYK9 .select__drop {
  width: 200px;
}

.header_exitBtn__fwrnS {
  display: none;
}
@media (min-width: 1200px) {
  .header_exitBtn__fwrnS {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/header.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;AACF;AACE;EACE,6BAAA;EACA,+BAAA;AACJ;AACI;EAJF;IAKI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,sBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EALF;IAMI,2BAAA;IACA,2BAAA;IACA,gCAAA;IACA,gCAAA;IACA,cAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,mBAAA;AACJ;AAGI;EACE,gBAAA;EACA,cAAA;AADN;AAGM;EAJF;IAKI,YAAA;EAAN;AACF;AAGI;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AADN;AAGM;EALF;IAMI,gBAAA;IACA,gBAAA;EAAN;AACF;AAEM;EAVF;IAWI,gBAAA;EACN;AACF;AAEI;EACE,cAAA;AAAN;AAEM;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAEQ;EALF;IAMI,gBAAA;IACA,gBAAA;EACR;AACF;AACQ;EAVF;IAWI,gBAAA;EAER;AACF;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EAEA,+CAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AAHJ;AAKI;EAfF;IAgBI,WAAA;IACA,YAAA;EAFJ;AACF;AAII;EApBF;IAqBI,WAAA;IACA,YAAA;EADJ;AACF;AAGI;EACE,kBAAA;EACA,UAAA;AADN;AAGM;EAJF;IAKI,WAAA;IACA,YAAA;EAAN;AACF;AAEM;EATF;IAUI,WAAA;IACA,YAAA;EACN;AACF;AAEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAAN;AAIE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAII;EAPF;IAQI,eAAA;EADJ;AACF;AAGI;EAXF;IAYI,uBAAA;EAAJ;AACF;AAGE;EACE,aAAA;AADJ;AAGI;EAHF;IAII,cAAA;EAAJ;AACF;AAKM;EACE,gBAAA;AAHR;AAKQ;EAHF;IAII,8CAAA;EAFR;AACF;AAQI;EACE,2BAAA;EACA,mBAAA;AANN;AAQM;EAJF;IAKI,gBAAA;EALN;AACF;AAOM;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AALR;AAUE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AARJ;;AAYA;EACE,aAAA;AATF;AAWE;EAHF;IAII,cAAA;IACA,kBAAA;EARF;AACF;AAYM;EACE,YAAA;AAVR;;AAgBA;EACE,aAAA;AAbF;AAeE;EAHF;IAII,aAAA;EAZF;AACF","sourcesContent":[".header {\n  width: 100%;\n  position: relative;\n  z-index: 3;\n  min-height: var(--header-height);\n  \n  &__wp {\n    transition: var(--transition);\n    transition-property: box-shadow;\n\n    @media (min-width: 1200px) {\n      position: fixed;\n      left: 0;\n      right: 0;\n      top: 0;\n      background-color: #fff;\n    }\n  }\n\n  &__inner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    @media (min-width: 1200px) {\n      flex-direction: row-reverse;\n      max-width: var(--container);\n      min-height: var(--header-height);\n      padding: 8px var(--grid-spacing);\n      margin: 0 auto;\n    }\n  }\n\n  &__links {\n    display: flex;\n    align-items: center;\n  }\n\n  &__logo {\n    a {\n      max-height: 48px;\n      display: block;\n\n      @media (min-width: 1200px) {\n        height: auto;\n      }\n    }\n\n    img {\n      width: auto;\n      max-height: 48px;\n      max-width: 100px;\n\n      @media (min-width: 640px) {\n        max-height: 40px;\n        max-width: 150px;\n      }\n\n      @media (min-width: 1200px) {\n        max-height: 40px;\n      }\n    }\n\n    &__container {\n      display: block;\n\n      svg, img {\n        width: auto;\n        max-height: 48px;\n        max-width: 100px;\n\n        @media (min-width: 640px) {\n          max-height: 40px;\n          max-width: 150px;\n        }\n\n        @media (min-width: 1200px) {\n          max-height: 40px;\n        }\n      }\n    }\n  }\n\n  &__auth {\n    display: flex;\n    align-items: center;\n  }\n\n  &__avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    border: 1px solid #FFF;\n    // background: transparent;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.16);\n    background: #EEE;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    overflow: hidden;\n\n    @media (min-width: 640px) {\n      width: 64px;\n      height: 64px;\n    }\n\n    @media (min-width: 1200px) {\n      width: 30px;\n      height: 30px;\n    }\n\n    svg {\n      position: relative;\n      z-index: 1;\n\n      @media (min-width: 640px) {\n        width: 30px;\n        height: 30px;\n      }\n\n      @media (min-width: 1200px) {\n        width: auto;\n        height: auto;\n      }\n    }\n\n    img {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      background: #fff;\n    }\n  }\n\n  &__name {\n    font-weight: 600;\n    color: #000;\n    margin-left: 8px;\n    font-size: 16px;\n    line-height: 100%;\n\n    @media (min-width: 640px) {\n      font-size: 22px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-md);\n    }\n  }\n\n  &--is-mob-hidden {\n    display: none;\n\n    @media (min-width: 1200px) {\n      display: block;\n    }\n  }\n\n  &--is-scrolled {\n    .header {\n      &__wp {\n        box-shadow: none;\n\n        @media (min-width: 1200px) {\n          box-shadow: 0 2px 8px rgba(152, 168, 188, .2);\n        }\n      }\n    }\n  }\n\n  .header__not-logined {\n    .header__inner {\n      flex-direction: row-reverse;\n      margin-bottom: 24px;\n\n      @media (min-width: 1200px) {\n        margin-bottom: 0;\n      }\n\n      .mob__login-btn {\n        font-size: 12px;\n        padding: 12px 24px;\n        background: #EEEEEE;\n        font-weight: 600;\n        border-radius: 12px;\n      }\n    }\n  }\n\n  .fio-container {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin-right: 16px;\n  }\n}\n\n.lang {\n  display: none;\n\n  @media (min-width: 1200px) {\n    display: block;\n    margin-right: 16px;\n  }\n\n  :global {\n    .select {\n      &__drop {\n        width: 200px;\n      }\n    }\n  }\n}\n\n.exitBtn {\n  display: none;\n\n  @media (min-width: 1200px) {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_header__A7NEZ`,
	"header__wp": `header_header__wp__HfD7X`,
	"header__inner": `header_header__inner__eBlOw`,
	"header__links": `header_header__links__JaL2y`,
	"header__logo": `header_header__logo__8KhJ7`,
	"header__logo__container": `header_header__logo__container__Xgayt`,
	"header__auth": `header_header__auth__cKTpv`,
	"header__avatar": `header_header__avatar__ONRMI`,
	"header__name": `header_header__name__ttvD2`,
	"header--is-mob-hidden": `header_header--is-mob-hidden__Hvq6Y`,
	"header--is-scrolled": `header_header--is-scrolled__FLcuh`,
	"header__not-logined": `header_header__not-logined__EVLlc`,
	"mob__login-btn": `header_mob__login-btn__MO7AY`,
	"fio-container": `header_fio-container__lCwJh`,
	"lang": `header_lang__HTYK9`,
	"exitBtn": `header_exitBtn__fwrnS`
};
export default ___CSS_LOADER_EXPORT___;
